import { Autocomplete, Typography } from '@equinor/eds-core-react'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import { PlantDto } from '@/core/models/types'
import { ALL_PLANTS_OPTION, normalizePlantSelection, useCurrentPlant } from '@/core/hooks-and-services/useCurrentPlant'

function PlantSelector() {
    const { currentPlant, setCurrentPlant, plants, isLoading } = useCurrentPlant()
    const [selectedPlant, setSelectedPlant] = useState<PlantDto | undefined>(currentPlant ?? ALL_PLANTS_OPTION)

    useEffect(() => {
        setSelectedPlant(currentPlant ?? ALL_PLANTS_OPTION)
    }, [currentPlant])

    const options: PlantDto[] = [ALL_PLANTS_OPTION, ...plants]

    const handleChange = ({ selectedItems }: { selectedItems: unknown[] }) => {
        const next = selectedItems[0] as PlantDto | undefined
        setSelectedPlant(next)
        if (next) void setCurrentPlant(normalizePlantSelection(next))
    }

    return (
        <Wrapper>
            <SelectorLabel id="plant-selector-label">Select plant</SelectorLabel>
            <StyledAutocomplete
                label=""
                aria-labelledby="plant-selector-label"
                placeholder="Select plant"
                options={options}
                optionLabel={(plant: unknown) => (plant as PlantDto).description ?? ''}
                selectedOptions={selectedPlant ? [selectedPlant] : []}
                onOptionsChange={handleChange}
                disabled={isLoading}
            />
        </Wrapper>
    )
}

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 400px;

    @media (max-width: 1024px) {
        width: 260px;
    }
`

const SelectorLabel = styled(Typography)`
    font-family: Equinor;
    font-size: 14px;
    font-weight: 400;
    color: white;
    white-space: nowrap;
`

const StyledAutocomplete = styled(Autocomplete)`
    width: 100%;
`

export default PlantSelector
